import dayjs, { Dayjs, ConfigType } from "dayjs";
import { IModel } from "@/loader";

export type PostOpenedStatus = "open" | "closed";

export interface IWPItem {
	id?: number;
	date?: ConfigType;
	date_gmt?: ConfigType;
	guid?: {
		rendered?: string;
		raw?: string;
	};
	modified?: ConfigType;
	modified_gmt?: ConfigType;
	slug?: string;
	status?: string;
	type?: string;
	link?: string;
	title?: {
		raw?: string;
		rendered?: string;
	};
	author?: number;
	comment_status?: PostOpenedStatus;
	ping_status?: PostOpenedStatus;
	template?: string;
	meta?: any[];
	permalink_template?: string;
	generated_slug?: string;
}

export class WPItem implements IWPItem, IModel<IWPItem> {
	public id!: number;
	public date!: Dayjs;
	public date_gmt!: Dayjs;
	public guid!: {
		rendered?: string;
		raw?: string;
	};
	public modified!: Dayjs;
	public modified_gmt!: Dayjs;
	public slug!: string;
	public status!: string;
	public type!: string;
	public link!: string;
	public title!: {
		raw?: string;
		rendered?: string;
	};
	public author!: number;
	public comment_status!: PostOpenedStatus;
	public ping_status!: PostOpenedStatus;
	public template!: string;
	public meta!: any[];
	public permalink_template!: string;
	public generated_slug!: string;

	public constructor(data: IWPItem = {}) {
		this.load(data);
	}

	public load(data: IWPItem) {
		this.id = Number.orDefault(data.id);
		this.date = dayjs.orDefault(data.date);
		this.date_gmt = dayjs.orDefault(data.date_gmt);
		this.modified = dayjs.orDefault(data.modified);
		this.modified_gmt = dayjs.orDefault(data.modified_gmt);
		this.slug = String.orDefault(data.slug);
		this.status = String.orDefault(data.status);
		this.type = String.orDefault(data.type);
		this.link = String.orDefault(data.link);
		this.author = Number.orDefault(data.author);
		this.comment_status = data.comment_status || "closed";
		this.ping_status = data.ping_status || "closed";
		this.template = String.orDefault(data.template);
		this.meta = Array.isArray(data.meta) ? data.meta.map(x => ({...x})) : [];
		this.permalink_template = String.orDefault(data.permalink_template);
		this.generated_slug = String.orDefault(data.generated_slug);
		this.guid = {
			raw: String.orDefault(data.guid?.raw),
			rendered: String.orDefault(data.guid?.rendered),
		};
		this.title = {
			raw: String.orDefault(data.title?.raw),
			rendered: String.orDefault(data.title?.rendered),
		};
	}

	public update(data: IWPItem) {
		if (data.id !== undefined) {
			this.id = Number.orDefault(data.id);
		}
		if (data.date !== undefined) {
			this.date = dayjs.orDefault(data.date);
		}
		if (data.date_gmt !== undefined) {
			this.date_gmt = dayjs.orDefault(data.date_gmt);
		}
		if (data.modified !== undefined) {
			this.modified = dayjs.orDefault(data.modified);
		}
		if (data.modified_gmt !== undefined) {
			this.modified_gmt = dayjs.orDefault(data.modified_gmt);
		}
		if (data.slug !== undefined) {
			this.slug = String.orDefault(data.slug);
		}
		if (data.status !== undefined) {
			this.status = String.orDefault(data.status);
		}
		if (data.type !== undefined) {
			this.type = String.orDefault(data.type);
		}
		if (data.link !== undefined) {
			this.link = String.orDefault(data.link);
		}
		if (data.author !== undefined) {
			this.author = Number.orDefault(data.author);
		}
		if (data.comment_status !== undefined) {
			this.comment_status = data.comment_status || "closed";
		}
		if (data.ping_status !== undefined) {
			this.ping_status = data.ping_status || "closed";
		}
		if (data.template !== undefined) {
			this.template = String.orDefault(data.template);
		}
		if (data.meta !== undefined) {
			this.meta = Array.isArray(data.meta) ? data.meta.map(x => ({...x})) : [];
		}
		if (data.permalink_template !== undefined) {
			this.permalink_template = String.orDefault(data.permalink_template);
		}
		if (data.generated_slug !== undefined) {
			this.generated_slug = String.orDefault(data.generated_slug);
		}
		if (data.guid !== undefined) {
			if (data.guid.raw !== undefined) {
				this.guid.raw = String.orDefault(data.guid?.raw);
			}
			if (data.guid.rendered !== undefined) {
				this.guid.rendered = String.orDefault(data.guid?.rendered);
			}
		}
		if (data.title !== undefined) {
			if (data.title.raw !== undefined) {
				this.title.raw = String.orDefault(data.title?.raw);
			}
			if (data.title.rendered !== undefined) {
				this.title.rendered = String.orDefault(data.title?.rendered);
			}
		}
	}

	public restData() {
		let data: any = {
			date: this.date.format("YYYY-MM-DD HH:mm:ss"),
			date_gmt: this.date_gmt.format("YYYY-MM-DD HH:mm:ss"),
			slug: this.slug,
			status: this.status,
			title: this.title.raw,
			author: this.author,
			comment_status: this.comment_status,
			ping_status: this.ping_status,
			template: this.template,
		};
		if (this.id > 0) {
			data.id = this.id;
		}
		if (this.meta.length) {
			data.meta = this.meta;
		}
		return data;
	}
}
